import React, { memo, useState, useEffect, useCallback } from 'react'
import { Form, DatePicker, Space } from 'antd'
import dayjs from 'dayjs'
import { isNull } from '@/utils/tools'
import styles from '../../index.module.less'
import { FormatMap, LayoutEnum } from '../../enum'


const { RangePicker } = DatePicker
const Index = (props: any) => {
  const { field, value, onChange } = props
  const { width, label, placeholder, layout, picker } = field
  const [inputValue, setInputValue] = useState<any>('')
  const format = FormatMap[picker]
  // 将时间戳字符串转换为 moment 对象
  const momentValue = (value ? value.map(item => dayjs(Number(item))) : null) as any


  const handleInputValueChange = v => {
    if (isNull(v)) {
      setInputValue("")
      onChange?.("")
      return;
    }
    // const valueStr = v.map(itme => changeDateToTimes(itme))
    const valueStr = [v[0].startOf('day').valueOf(), v[1].endOf('day').valueOf()]
    // const startVal = dates[0].startOf('day').format('YYYY-MM-DD HH:mm:ss');
    // const endVal = dates[1].endOf('day').format('YYYY-MM-DD HH:mm:ss');

    // console.log("handleInputValueChange2", valueStr)
    setInputValue(valueStr)
    onChange?.(valueStr)
  }

  return (
    <div className={styles.innerFieldWrap}>
      {layout === LayoutEnum.HORIZONTAL ? (
        <Space.Compact block>
          <div className={styles.addon}>{label}</div>
          <RangePicker
            picker={picker}
            format={format}
            value={momentValue}
            style={{ width }}
            onChange={handleInputValueChange}
          />
        </Space.Compact>
      ) : (
        <div className={styles.vertical}>
          <div className={styles.addon}>{label}</div>
          <RangePicker
            picker={picker}
            format={format}
            value={momentValue}
            style={{ width }}
            onChange={handleInputValueChange}
          />
        </div>
      )}
    </div>
  )
}

export default Index
